import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { useTranslation } from '../../../../../src/i18n';
import CardBox from '../../../../../components/CardBox';
import { TP } from '../../../../../constants/consts';
import TitledBlock from '../../../../../components/TitledBlock';
import EditCardButtons from '../../../../../components/EditComponents/EditCardButtons';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  lastUpdate: {
    marginLeft: 'auto',
  },
}));

const EditSynopsisCard = ({ className, onDelete, onEdit, document }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <CardBox className={cn(classes.root, className)}>
      <TitledBlock title={t(`${TP}.m_LANG`)}>{document?.synopsis?.language?.name}</TitledBlock>
      <EditCardButtons editClick={onEdit} editButtonName={t(`${TP}.FN_EDIT`)} onDelete={onDelete} />
    </CardBox>
  );
};

EditSynopsisCard.propTypes = {
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  document: PropTypes.object.isRequired,
};

export default memo(EditSynopsisCard);
